<template>
  <div>
    <div class="headline text-center">
      {{ $t('tuneMic') }}
    </div>
    <div class="my-6">
      <MicrophoneCheck @checked="microphoneChecked">
        <template #text>
          &laquo; {{ $t('micSettingsCheck') }}&raquo;.
        </template>
      </MicrophoneCheck>
    </div>
  </div>
</template>

<script>
import MicrophoneCheck from '@huntica/huntica-interview-module/src/components/MicrophoneCheck.vue';

export default {
  name: 'OfficeInterviewMicrophoneCheck',
  components: {
    MicrophoneCheck,
  },
  methods: {
    microphoneChecked(value) {
      if (value === true) {
        this.$emit('done');
      }
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  tuneMic: Setup your microphone
  micSettingsCheck: Setup your microphone before the interview
</i18n>

<i18n locale="ru" lang="yaml">
  tuneMic: Настройте микрофон
  micSettingsCheck: Проверка настройки микрофона перед началом очного собеседования
</i18n>
